import axios from 'axios'
import moment from 'moment'

export const data_venda = (value, numero_nf) => {
    return {
        emission: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        "status": "COMMITTED",
        "customer_id": "7e39afd9-682d-46d5-a48e-8e66766747ad",
        "services": [
            {
                "quantity": 1,
                "service_id": "fe4e817b-2030-49c2-959d-3402ebbb12b9",
                "value": value
            }
        ],
        "payment": {
            "type": "CASH",
            "installments": [
                {
                    "number": 1,
                    "value": value,
                    "due_date": moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                    "status": "PENDING"
                }
            ]
        },
        "notes": `ESTOU FAZENDO TESTES | Número NF: ${numero_nf}`
    }
}

export const venda = async (data, token) => {
    const res = await axios.post(`https://api.contaazul.com/v1/sales`,
        data, {
        headers: {
            Authorization: 'Bearer ' + token,
            'content-type': 'application/json'
        }
    }
    )
    console.log(res)
    return res
}


// WEBPACK FOOTER //
// ./src/pages/ContaAzul/services/venda.js